import { SponsorRouteData } from '../sponsor-route-data';
import { UrlBuilder } from '../../core/url-builder/url-builder';
import { ActivatedRoute } from '@angular/router';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { TabCategory } from '../../documents';
import { map, refCount, publishReplay } from 'rxjs/operators';
import { routeData } from '../../shared/route-helpers';
import { SponsorStudySiteIdentity } from '../sites/sponsor-study-site-identity';

@Component({
    selector: 'sponsor-test-results',
    template: require('./sponsor-test-results.component.html'),
    styles: [require('./sponsor-test-results.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SponsorTestResultsComponent {
    public tabs: Observable<TabCategory[]>;
    public selectedSiteIdentity$: Observable<SponsorStudySiteIdentity>;
    public siteIdentities$: Observable<SponsorStudySiteIdentity[]>;

    constructor(
        private urlBuilder: UrlBuilder,
        private sponsorRouteData: SponsorRouteData,
        private route: ActivatedRoute,
    ) {
        this.siteIdentities$ = this.route.data.pipe(map(x => x[routeData.studySiteIdentities] as SponsorStudySiteIdentity[]));

        this.selectedSiteIdentity$ = this.route.data.pipe(
            map(x => x[routeData.selectedSiteIdentity] as SponsorStudySiteIdentity),
            publishReplay(1),
            refCount());

        this.tabs = this.selectedSiteIdentity$.pipe(
            map(selectedSite => {
                if (!selectedSite) {
                    return [];
                }
                const labResultsUrl = this.urlBuilder
                    .esa()
                    .sponsor()
                    .study(this.sponsorRouteData.snapshot.selectedStudy)
                    .testResults(selectedSite.siteId)
                    .standardTestResults()
                    .url();
                const microbiologyUrl = this.urlBuilder
                    .esa()
                    .sponsor()
                    .study(this.sponsorRouteData.snapshot.selectedStudy)
                    .testResults(selectedSite.siteId)
                    .microbiology()
                    .url();
                return [{ name: 'Standard', url: labResultsUrl }, { name: 'Microbiology', url: microbiologyUrl }];
            }),
            publishReplay(1),
            refCount());
    }

    public onSiteIdentityChanged(siteIdentity: SponsorStudySiteIdentity) {
        this.urlBuilder
            .esa()
            .sponsor()
            .study(this.sponsorRouteData.snapshot.selectedStudy)
            .testResults(siteIdentity.siteId)
            .navigate({ preserveFragments: true });
    }
}
